import {Companies, Feuds} from "./models.js";

function FeudItem() {

    // String
    const name = null;
    const description = null;
    const consequence = null;
    const requirement = null;
    const category = null;

    // Integer
    const level = 1;
    const xp = 0;
    const baseHype = 10;

    // Boolean
    const oneAtATime = false;
    const unlocked = true;
    const standard = false;
    const singles = true;
    const tag = false;
    const faction = false;
    const directFeud = false;
    const oneWayConsequence = false;

    // Foreign keys
    const companyId = null;

    return {
        name,
        description,
        consequence,
        requirement,
        category,
        level,
        xp,
        baseHype,
        oneAtATime,
        unlocked,
        standard,
        singles,
        tag,
        faction,
        directFeud,
        oneWayConsequence,
        companyId,
    };
}

function getFeudItemFeuds(feudItem) {
    return Feuds.find({'feudItemId': feudItem.$loki});
}

function addFeudItemFeuds(feudItem, feuds) {
    feuds.forEach(c => {
        c.feudItemId = feudItem.$loki
    });
}

function removeFeudItemFeuds(feudItem, feuds) {
    feuds.forEach(c => {
        c.feudItemId = null
    });
}

function getFeudItemCompany(feudItem) {
    return Companies.find({'$loki': feudItem.companyId})[0];
}


export { FeudItem, addFeudItemFeuds, removeFeudItemFeuds, getFeudItemFeuds }
